import {Inject, Injectable} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { SourceConfig } from '~shared/models/source.interface';
import { ElementPlaceEnum } from '~shared/constants';


@Injectable({
  providedIn: 'root',
})
export class SourcesInsertService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public setAll(elements: SourceConfig[]) {
    elements.forEach((element) => {
      this.addElement(element);
    });
  }

  private addElement(element: SourceConfig) {
    const parent = this.getParent(element.place);
    const sourceElement = this.getElementByType(element);
    parent.appendChild(sourceElement);
  }

  private getParent(place) {
    if (place === ElementPlaceEnum.HEAD) {
      return this.document.getElementsByTagName(place)[0];
    } else {
      return this.document.getElementsByTagName(ElementPlaceEnum.BODY)[0];
    }
  }

  private getElementByType (element) {
    const sourceElement = this.document.createElement(element.element);
    const attributes = element.attributes;
    if (Array.isArray(attributes) && attributes.length){
      element.attributes.forEach((elem) => {
        sourceElement[elem.name] = elem.value;
      });
    }
    return sourceElement;
  }
}
